import React, { useState, useRef } from 'react';
import FloatInput from 'components/generic-components/FloatInput';
import CustomButton from 'components/generic-components/ButtonComponent';
import { CameraIconPlus, DeleteBlackIcon } from 'components/Icons';
import { useTranslation } from 'react-i18next';

const Earn = () => {
  const { t } = useTranslation();
  const [attachment, setAttachment] = useState([]);
  const [secondAttachment, setSecondAttachment] = useState([]);
  const attachmentInputRef = useRef(null);
  const secondAttachmentInputRef = useRef(null);

  const handleFileSelect = e => {
    const file = e.target.files[0];
    if (attachment.length === 1) return;
    setAttachment(prevState => [...prevState, { file, url: URL.createObjectURL(file) }]);
  };

  const handleSecondFileSelect = e => {
    const file = e.target.files[0];
    if (secondAttachment.length === 1) return;
    setSecondAttachment(prevState => [...prevState, { file, url: URL.createObjectURL(file) }]);
  };

  const handleSecondFileDelete = url => {
    setSecondAttachment(attachment.filter(attach => attach.url !== url));
  };

  const handleFileDelete = url => {
    setAttachment(attachment.filter(attach => attach.url !== url));
  };

  return (
    <div className={'col-12 col-md-6 px-3 py-4'} style={{ minHeight: '100%' }}>
      <div className="billing-container">
        <h5>{t('Bank account')}</h5>
      </div>
      <div className="earn-form-container">
        <FloatInput label="Account name" />
        <FloatInput label="routing number" type="number" />
        <FloatInput label="Account number" type="number" />
      </div>
      <div className="earn-verification-container">
        <div className="earn-id-container">
          {attachment.map(file => {
            return (
              <div key={file.url}>
                <img src={file.url} width={156} height={100} alt="attachemnts" />
                <div style={{ position: 'relative' }}>
                  <button
                    className="earn-delete-button"
                    onClick={() => {
                      handleFileDelete(file.url);
                    }}
                  >
                    <DeleteBlackIcon />
                  </button>
                </div>
              </div>
            );
          })}
          <p style={{ display: attachment?.length ? 'none' : 'flex' }}>
            {t(`UPLOAD_ID`)}
          </p>
          <div className="earn-camera-container" style={{ display: attachment?.length ? 'none' : 'flex' }}>
            <CameraIconPlus
              onClick={() => {
                attachmentInputRef.current.click();
              }}
            />
          </div>
          <input
            type="file"
            className="main-input"
            onChange={e => handleFileSelect(e)}
            style={{ display: 'none' }}
            ref={attachmentInputRef}
            accept=".jpg,.jpeg,.webp,.gif,.bmp,.png"
          />
        </div>

        <div className="earn-id-container  ">
          {secondAttachment.map(file => {
            return (
              <div key={file.url}>
                <img src={file.url} width={156} height={100} alt="attachemnts" />
                <div style={{ position: 'relative' }}>
                  <button
                    className="earn-delete-button"
                    onClick={() => {
                      handleSecondFileDelete(file.url);
                    }}
                  >
                    <DeleteBlackIcon />
                  </button>
                </div>
              </div>
            );
          })}
          <p style={{ display: secondAttachment?.length ? 'none' : 'flex' }}>
            {t(`UPLOAD_ID_PHOTO`)}
          </p>
          <div className="earn-camera-container" style={{ display: secondAttachment?.length ? 'none' : 'flex' }}>
            <CameraIconPlus
              onClick={() => {
                secondAttachmentInputRef.current.click();
              }}
            />
          </div>
          <input
            type="file"
            className="main-input"
            onChange={e => handleSecondFileSelect(e)}
            style={{ display: 'none' }}
            ref={secondAttachmentInputRef}
            accept=".jpg,.jpeg,.webp,.gif,.bmp,.png"
          />
        </div>
      </div>
      <div className="earn-confirm-container">
        <div className="radio-item earn-card">
          <input type="radio" id="ritemb2" name="ritem2" value="ropt3" />
          <label for="ritemb2">{t('Must be 18 years old to earn')}</label>
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 28 }}>
        <CustomButton btnText="Submit" customClass="earn-confirm-button" />
      </div>
    </div>
  );
};

export default Earn;
